import {createContext, SetStateAction, useContext} from "react";

export interface YeuCauHoTroContextProps {
  dsYeuCau: any;
  setDsYeuCau: SetStateAction<any>;
  detailPhieuYeuCau: any;
  setDetailPhieuYeuCau: SetStateAction<any>;

}

const initialContext = {
  dsYeuCau: [],
  setDsYeuCau: () => { },
  detailPhieuYeuCau: [],
  setDetailPhieuYeuCau: () => { },
}

export const YeuCauHoTroContext = createContext<YeuCauHoTroContextProps>(initialContext);

export const useYeuCauHoTroContext = () => useContext(YeuCauHoTroContext);

export const YeuCauHoTroProvider = YeuCauHoTroContext.Provider;
